// extracted by mini-css-extract-plugin
export var searchHeader = "_a9-0";
export var searchHeaderDark = "_a9-1";